<template>
    <div>
        <InitialLoading :init-loading='initLoading' />
        <div v-if='!initLoading'>
            <div>
                <carousel
                    :items='columns'
                    :margin='4'
                    :nav='false'
                    :autoplay='true'
                    style='direction: ltr'
                    v-if='realEstate.photos && realEstate.photos.length>2'
                >
                    <img
                        v-for='(item,i) in realEstate.photos'
                        :src='public_url + "/"+ item'
                        :key='i'
                        height='450'
                        :alt='realEstate.title'
                    />
                </carousel>
                <carousel
                    :items='columns2'
                    :margin='4'
                    :nav='false'
                    :autoplay='true'
                    style='direction: ltr'
                    v-else-if='realEstate.photos && realEstate.photos.length>1'
                >
                    <img
                        v-for='(item,i) in realEstate.photos'
                        :src='public_url + "/"+ item'
                        :key='i'
                        height='450'
                        :alt='realEstate.title'
                    />
                </carousel>
                <div class=' text-center' v-else-if='realEstate.photos'>
                    <img
                        class='mx-1'
                        v-for='(item,i) in realEstate.photos'
                        :src='public_url + "/"+ item'
                        :key='i'
                        height='450'
                        :alt='realEstate.title'
                    />
                </div>
                <v-img
                    v-else
                    height='250'
                    :src='realEstate.cover || `/assets/img-none.svg`'
                />
            </div>
            <v-container class='ad-detail'>
                <v-row v-if='!loadingRealEstateData && realEstate._id'>
                    <v-col
                        cols='12'
                        sm='12'
                        md='9'
                        lg='9'

                    >
                        <Details :ads='ad' :realEstate='realEstate' :bookmarkable='true'>
                            <template slot='action'>
                                <v-divider />
                                <v-card-actions class='justify-space-between'>
                                    <div>
                                        <v-btn color='primary'
                                               v-if="ad.status==='APPROVED'"
                                               @click='requestNumber'
                                               :disabled='!!phone'>
                                            مشاهده اطلاعات تماس
                                        </v-btn>
                                        <v-chip color='muted' v-else>آگهی منقضی شده</v-chip>
                                    </div>
                                    <a target='_blank' :href="'tel:'+phone" v-if='phone'>
                                        <v-chip>
                                            {{ phone }}
                                            <v-icon class='mr-2'>mdi-phone</v-icon>
                                        </v-chip>
                                    </a>
                                </v-card-actions>
                            </template>
                        </Details>

                        <v-card class='mb-4' outlined>
                            <v-card-title class='d-flex align-center justify-space-between'>
                                <h3 style='font-size: 16px'>
                                    دسته بندی های آگهی
                                </h3>

                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <div class='d-flex flex-wrap'>
                                    <v-chip
                                        v-for='(item, index) in keywords' :key='index'
                                        class='p-2 mx-1 my-1'
                                        target='_blank'
                                        variant='secondary'
                                        :to='{name:"Explore", query:item.query}'
                                    >
                                        {{ item.text }}
                                    </v-chip>
                                </div>
                            </v-card-text>
                        </v-card>

                        <v-card class='mb-4' outlined v-if='advertisements.length'>
                            <v-card-title class='d-flex align-center justify-space-between'>
                                <h3 style='font-size: 16px'>
                                    آگهی های مشابه
                                </h3>

                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <div class='row'>
                                    <div class='col col-md-4 px-2' v-for='ad in advertisements' :key='ad._id'>
                                        <ad-item :item='ad' />
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>

                    </v-col>
                    <v-col cols='12' sm='12' md='3' lg='3'>
                        <send-message-to-agent v-if='ad.agent && ad.agent._id !== user.agent' :user='ad.agent.user' />
                        <send-message-to-owner v-if='ad.user && ad.user._id' :user='ad.user' />
                        <v-divider class='mb-3' />
                        <div v-if='specialAds.length>0'
                        >
                            <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>
                                <v-icon class='ml-2'>mdi-star-shooting-outline</v-icon>
                                <span>آگهی های ویژه</span>
                            </h3>

                            <div class='mb-2' v-for='item in specialAds'
                                 :key='item._id'>
                                <AdItem :item='item' />
                            </div>

                        </div>
                    </v-col>
                </v-row>
            </v-container>


            <!--Dialog show image-->
            <v-dialog v-model='viewPhotoDialog'>
                <v-card>
                    <v-card-text class='pa-2 view-img'>
                        <v-img
                            class='elevation-10 mb-2'
                            alt='تصویر آگهی'
                            :src='`${public_url}/${selectedPhotoForView}`'
                            contain
                            height='auto'
                        >
                            <template v-slot:placeholder>
                                <v-skeleton-loader type='image' />
                            </template>
                        </v-img>
                        <v-btn
                            small
                            fab
                            class='btn'
                            @click='viewPhotoDialog = false'
                        >
                            <v-icon>
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-dialog>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';
    import _ from 'lodash';
    import carousel from 'vue-owl-carousel';

    import InitialLoading from '@/components/initialLoading';
    import Details from '@/components/Explore/Details';
    import SendMessageToAgent from '@/components/Explore/sendMessageToAgent';
    import SendMessageToOwner from '@/components/Explore/sendMessageToOwner';

    import AdItem from '@/components/Explore/AdItem';

    export default {
        components: {
            Details,
            InitialLoading,

            carousel,
            SendMessageToAgent,
            SendMessageToOwner,
            AdItem
        },
        name: 'AdDetail',
        data() {
            return {
                advertisement_id: null,
                err: {},
                // Dialogs
                viewPhotoDialog: false,
                showOwnerInfoDialog: false,

                selectedDays: [],
                selectedDate: null,
                loadingPayByWallet: false,
                offCode: '',

                model: null,
                initLoading: true,
                // Loadings
                loadingRealEstateData: false,


                // State of photo
                photo: null,
                selectedPhotoForView: null,

                // Index of photo
                index: null,

                // Advertisement id
                ad_id: null,
                // RealEstate Data
                realEstate: {
                    photos: []
                },
                ad: {},
                phone: null,

                advertisements: [],
                keywords: [],
                loadingFetchSpecialAds: true,
                specialAds: [],
                source: axios.CancelToken.source()
            };
        },
        methods: {


            /**
             * Array type checker
             * @param {any} item
             * @return {boolean} return true if item is array
             */
            isArray: function(item) {
                return _.isArray(item);
            },
            localDate(date) {
                const options = {
                    localeMatcher: 'lookup',
                    formatMatcher: 'basic',
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit'
                };
                return new Date(date).toLocaleDateString('fa-IR', options);
            },
            listOfDays(i) {
                let date = new Date();
                return {
                    dayName: this.moment(date.setDate(date.getDate() + i)).format('dddd'),
                    jDate: this.moment(date.setDate(date.getDate())).format('jMM/jDD'),
                    date: this.moment(date).format('YYYY/MM/DD'),
                    jDateName: this.moment(date.setDate(date.getDate())).format('jDD jMMMM')
                };
            },


            /**
             * View Photo
             * @param {number} index index of photo
             */
            viewPhoto(index) {
                this.viewPhotoDialog = true;
                this.selectedPhotoForView = this.realEstate.photos[index];
            },

            /**
             * get RealEstate advertisement data
             * @returns {Promise<{realEstate:{}}>} RealEstate Object
             */
            async fetchAdvertisementData() {
                this.loadingRealEstateData = true;
                await axios
                    .get(`/api/ads/${this.ad_id}`)
                    .then(res => {
                        this.advertisement_id = res.data.ads._id;
                        this.realEstate = res.data.realEstate;
                        this.ad = res.data.ads;

                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]} ${this.translate.ads.realEstatesType[this.realEstate.type]} ${this.realEstate.area - 50} تا ${this.realEstate.area + 50} متری در ${this.realEstate.province.title}`,
                            query: {
                                maxArea: this.realEstate.area + 50,
                                minArea: this.realEstate.area - 50,
                                type: [this.ad.type],
                                realEstateType: [this.realEstate.type],
                                province: this.realEstate.province._id
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]} ${this.translate.ads.realEstatesType[this.realEstate.type]} ${this.realEstate.area - 20} تا ${this.realEstate.area + 20} متری`,
                            query: {
                                maxArea: this.realEstate.area + 20,
                                minArea: this.realEstate.area - 20,
                                type: [this.ad.type],
                                realEstateType: [this.realEstate.type]
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]} ${this.translate.ads.realEstatesType[this.realEstate.type]} در ${this.realEstate.province.title}`,
                            query: {
                                type: [this.ad.type],
                                realEstateType: [this.realEstate.type],
                                province: this.realEstate.province._id
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]} ${this.translate.ads.realEstatesType[this.realEstate.type]}`,
                            query: {
                                type: [this.ad.type],
                                realEstateType: [this.realEstate.type]
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.realEstatesType[this.realEstate.type]} ${this.realEstate.area - 10} تا ${this.realEstate.area + 10} متری`,
                            query: {
                                maxArea: this.realEstate.area + 10,
                                minArea: this.realEstate.area - 10,
                                realEstateType: [this.realEstate.type]
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]} ${this.realEstate.area - 5} تا ${this.realEstate.area + 5} متری`,
                            query: {
                                maxArea: this.realEstate.area + 5,
                                minArea: this.realEstate.area - 5,
                                type: [this.ad.type]
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]} در ${this.realEstate.province.title}`,
                            query: {
                                type: [this.ad.type],
                                province: this.realEstate.province._id
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.realEstatesType[this.realEstate.type]} در ${this.realEstate.province.title}`,
                            query: {
                                realEstateType: [this.realEstate.type],
                                province: this.realEstate.province._id
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]}`,
                            query: {
                                type: [this.ad.type]
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.realEstatesType[this.realEstate.type]}`,
                            query: {
                                realEstateType: [this.realEstate.type]
                            }
                        });
                        this.keywords.push({
                            text: `${this.realEstate.area - 20} تا ${this.realEstate.area + 20} متری`,
                            query: {
                                minArea: this.realEstate.area - 20,
                                maxArea: this.realEstate.area + 20
                            }
                        });
                        this.keywords.push({
                            text: `${this.realEstate.province.title}`,
                            query: {
                                province: this.realEstate.province._id
                            }
                        });
                        this.keywords.push({
                            text: `${this.realEstate.province.title} ${this.realEstate.city.title}`,
                            query: {
                                province: this.realEstate.province._id,
                                cities: [this.realEstate.city._id]
                            }
                        });
                        this.keywords.push({
                            text: `${this.translate.ads.type[this.ad.type]} ${this.translate.ads.realEstatesType[this.realEstate.type]} در ${this.realEstate.province.title + ' ' + this.realEstate.city.title}`,
                            query: {
                                type: [this.ad.type],
                                realEstateType: [this.realEstate.type],
                                province: this.realEstate.province._id,
                                cities: [this.realEstate.city._id]
                            }
                        });


                        this.loadingRealEstateData = false;


                    })
                    .catch(err => {
                        this.loadingRealEstateData = false;
                        console.error(err);
                    });
            },
            async fetchSimilarAdvertisements() {
                // get similar ads
                await axios
                    .get(`/api/ads/${this.ad_id}/similar`, {
                        params: {
                            filter: {
                                type: [this.ad.type],
                                realEstateType: [this.realEstate.type],
                                cities: [this.realEstate.city._id],
                                province: this.realEstate.province._id,
                                minArea: this.realEstate.area - 50,
                                maxArea: this.realEstate.area + 50
                            }
                        }
                    })
                    .then(async res => {
                        this.advertisements = res.data.advertisements;
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
            async requestNumber() {
                await axios.get(`/api/ads/${this.ad_id}/requestNumber`).then(res => {
                    let ad = res.data.ad;
                    if (ad.user && ad.user.phone) {
                        this.phone = ad.user.phone;
                    } else if (ad.agent && ad.agent.user && ad.agent.user.phone) {
                        this.phone = ad.agent.user.phone;
                    }
                }).catch();
            },
            async updateInsight() {
                axios.post(`/api/ads/${this.ad_id}/insight?visited=1`).catch();
            },

            async fetchSpecialAds() {
                await axios
                    .get(`/api/ads/re/special`, { cancelToken: this.source.token })
                    .then(({ data }) => {
                        this.specialAds = data.specialAds;
                    })
                    .catch(err => {
                        console.error(err);
                    });
                this.loadingFetchSpecialAds = false;
            },
            ...mapActions(['setWallet', 'showNavigation', 'showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        async created() {
            this.reserved_id = this.$route.query.reserved_id;
            this.ad_id = this.$route.params.ad_id;
            await this.fetchAdvertisementData();
            await this.fetchSimilarAdvertisements();

            this.initLoading = false;
            let href = window.location.pathname + window.location.search;
            await this.setBreadCrumbsTemp({
                key: 'adDetail',
                value: {
                    text: `جزئيات آگهی`,
                    href: href
                }
            });
        },
        async updated() {
            await this.showBreadCrumbs(['explore', 'adDetail']);
        },
        async mounted() {
            await this.fetchSpecialAds();
            await this.updateInsight();
        },
        computed: {

            columns() {
                if (this.$vuetify.breakpoint.xl) {
                    return 3;
                }

                if (this.$vuetify.breakpoint.lg) {
                    return 3;
                }

                if (this.$vuetify.breakpoint.md) {
                    return 2;
                }

                return 1;
            },
            columns2() {
                if (this.$vuetify.breakpoint.xl) {
                    return 2;
                }

                if (this.$vuetify.breakpoint.lg) {
                    return 2;
                }

                if (this.$vuetify.breakpoint.md) {
                    return 2;
                }

                return 1;
            },
            ...mapState(['public_url', 'wallet', 'user', 'availableFeatures', 'translate'])
        }
    };
</script>

<style scoped lang='scss'>
    .ad-detail {
        .advanced-search {
            .v-text-field__details {
                display: none;
            }
        }

        .view-img {
            position: relative;

            .btn {
                position: absolute;
                top: 10px;
                left: 10px;
            }
        }

        .custom-row-realEstate {
            .v-card__text {
                padding-bottom: 0;
            }
        }

        .custom-row-realEstate-features {
            padding-bottom: 8px;

            .v-card__text {
                padding: 2px 16px;
            }
        }

        .image-uploader {
            display: grid;
            grid-gap: 16px;
            grid-template-columns: repeat(2, 1fr);
            justify-items: center;
            align-items: center;
            @media screen and (min-width: 600px) {
                grid-template-columns: repeat(7, 1fr);
            }

            .image-container {
                position: relative;

                .delete-btn {
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                .see-btn {
                    position: absolute;
                    top: 0;
                    right: 0;
                }

                .select-for-cover {
                    position: absolute;
                    bottom: 0;
                }
            }

            .upload-photo-loader {
                width: 86px;
                height: 86px;
                display: flex;
                justify-items: center;
                align-items: center;

                > div {
                    margin: auto;
                }
            }

            .v-image {
                border-radius: 2.5px;

                .v-responsive__sizer {
                    padding: 0 !important;
                }
            }

            .v-text-field {
                margin: 0;
                padding-top: 0;

                .v-input__prepend-outer {
                    margin: 0;

                    .v-input__icon {
                        width: 86px;
                        height: 86px;

                        .v-icon {
                            border: 1px dashed;
                            border-radius: 2.5px;
                            padding: 19.5px;
                            font-size: 45px;

                            &::after {
                                transform: none;
                                border-radius: 2.5px;
                            }
                        }

                    }
                }
            }
        }

        .custom-stepper-header {
            overflow-x: scroll;

            .full-width {
                min-width: 50px;
            }

            hr {
                display: block;
                flex: 1 1 0;
                max-width: 100%;
                height: 0;
                max-height: 0;
                border: solid;
                border-width: thin 0 0 0;
                transition: inherit;
            }

            .v-stepper__step {
                padding: 0;
                margin: 0 4px;
                justify-content: space-between;

                .v-stepper__step__step {
                    margin: 0;
                    height: 15px;
                    min-width: 15px;
                    width: 15px;
                    font-size: 10px;

                    .v-icon__svg {
                        width: 12px;
                        height: 12px;
                    }
                }

                .v-stepper__label {
                    white-space: nowrap;
                    margin-top: 4px;
                    font-size: 12px;
                }
            }
        }
    }

    .carousel-visit-time-list {
        position: relative;

        :deep() > span[id^="carousel_"] {
            z-index: 2;
            position: absolute;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;

            .v-btn {
                width: 30px;
                height: 30px;
            }
        }

        :deep() {
            .owl-carousel {

                .owl-stage-outer {
                    .owl-stage {
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                }
            }
        }
    }

    .prev-slide {
        position: absolute;
        top: 30%;
        left: 0;
    }

    .next-slide {
        position: absolute;
        top: 30%;
        right: 0;
    }

    .reserve-visit-time-dialog {
        .off-code {
            :deep().v-input__control {
                height: 32px;
                min-height: 32px;
            }

            .off-code-btn {
                height: 32px;
                min-width: 46px;
                padding: 0 8px;
            }
        }
    }
</style>
